require('./brokerFundsView.scss');

const PropTypes = require('prop-types');
// @vendor
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');

// @commons
const { CommercialAdsCCValidated: CommercialAds } = require('components/commons/commercialAds/commercialAds');
const { OKCover } = require('commonsComponents/OKCover');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKLink } = require('commonsComponents/OKLink');
const { ContentBox } = require('commonsComponents/contentBox');
const { LoadingSection } = require('commonsComponents/loadingSection');

// @components
const BrokerTruncatedBreadcrumb = require('components/broker/brokerTruncatedBreadcrumb/brokerTruncatedBreadcrumb');
const BrokerMyInvestmentsProducts = require('components/broker/myInvestments/brokerMyInvestmentsProducts/brokerMyInvestmentsProducts');
const BrokerMyInvestmentsContracts = require('components/broker/myInvestments/brokerMyInvestmentsContracts/brokerMyInvestmentsContracts');
const { BrokerCustomProductLoader } = require('components/broker/brokerCustomProductLoader/brokerCustomProductLoader');
const {
    BrokerInvestmentSpecialist
} = require('components/broker/brokerInvestmentSpecialist/brokerInvestmentSpecialist');
const {
    BrokerMostPopularOfMonth
} = require('components/broker/brokerMostPopularOfMonth/brokerMostPopularOfMonth');
const BrokerInformationAboutProduct = require('components/broker/brokerInformationAboutProduct/brokerInformationAboutProduct');
const { BrokerSearchWidget } = require('components/broker/brokerSearchWidget/brokerSearchWidget');
import FeatureTogglingRender from 'components/conditionalRender/featureTogglingRender';
const { taggingEventHandled } = require('utilities/taggingEventHandled');
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');
const BrokerRiskIndicator = require('components/broker/brokerRiskIndicator/brokerRiskIndicator');

// @helpers
const { formatText, FormattedText, getLanguage } = require('core/i18n').i18n;
const showGDI = require('core/environmentConfig').GDI;
const { getPublicSitePath, getPublicSiteUrl } = require('core/apiURLBuilder');

// @actions
const BrokerStocksByTypeActions = require('actions/brokerStocksByType');
const BrokerStocksByContractActions = require('actions/brokerWallets');
const BrokerOpenTraderActions = require('actions/brokerOpenTrader');
const BrokerOrdersAndMovementsActions = require('actions/brokerOrdersAndMovements');
const BrokerInternalTransferFundsActions = require('actions/brokerInternalTransferFunds');
const brokerContractState = require('actions/brokerContractState');
const BrokerSearchWidgetActions = require('actions/brokerSearchWidget');
const BrokerProductFiltersSearchActions = require('actions/brokerProductFiltersSearch');

// @utilites
const {
    PROC_BROKER_FUNDS_PG_NAME,
} = require('utilities/tagging');

// @constants
const { scrollToTop } = require('commonsUtilities/scrollUtils');
const {
    MYPROFILE_BROKER_URL,
    TYPE_FUNDS,
    TYPE_CM,
    BROKER_MOST_POPULAR_OF_MONTH_FUNDS_TAB,
    MYPROFILE_BROKER_EXPLORE_FUNDS_URL,
    CNMV_URL,
} = require('constants/index');
const {
    DIVERSIFIED_INVESTMENT,
    MORNINGSTAR_MOST_POPULAR,
} = require('constants/flagBasedFeatures');


class BrokerFundsView extends React.Component {
    constructor(props) {
        super(props);

        this.handleBuyClick = this.handleBuyClick.bind(this);
        this.handleBuySearchClick = this.handleBuySearchClick.bind(this);
        this.buildFundsTabbedContent = this.buildFundsTabbedContent.bind(this);
        this.breadcrumb = [
            {
                text: formatText('funds-investments'),
                url: MYPROFILE_BROKER_URL
            },
            {
                text: formatText('funds-funds'),
                url: ''
            }
        ];
    }

    componentDidMount() {
        const { immBrokerMyInvestments } = this.props;

        this.props.getStocksByType();
        this.props.getStocksContracts();
        if (immBrokerMyInvestments.get('fetchSuccess')) {
            this.setPageInteraction();
        }
        scrollToTop();
    }

    componentDidUpdate(prevProps) {
        const { immBrokerMyInvestments } = this.props;
        const immBrokerMyInvestmentsPrev = prevProps.immBrokerMyInvestments;

        if (
            immBrokerMyInvestments.get('fetchSuccess') &&
            !immBrokerMyInvestmentsPrev.get('fetchSuccess')
        ) {
            this.setPageInteraction();
        }
    }

    setPageInteraction() {
        const { immBrokerMyInvestments } = this.props;
        const productStatus = immBrokerMyInvestments.getIn(['products', 'funds', 'total']) > 0
            ? 'active'
            : 'empty';
        const customData = {
            nombrePagina: PROC_BROKER_FUNDS_PG_NAME,
            productStatus: productStatus,
        };
        this.setState({
            setProductStatus: true,
        })
        window && window.utag && window.utag.view && window.utag.view(customData)
    }

    buildBrokerMostPopularOfMonthContent() {
        return (
            <BrokerMostPopularOfMonth
                defaultTab={BROKER_MOST_POPULAR_OF_MONTH_FUNDS_TAB}
                deactivateTabsMode={true}
                titleKey="broker-mostPopularOfMonthTitleFundsLanding"
                toolTipContentKey="mostPopularOfMonth-mostPopularOfMonthTooltipFundsLanding"
                pageName={PROC_BROKER_FUNDS_PG_NAME}
            />
        );
    }

    buildCallMeBackContent() {
        return <BrokerInvestmentSpecialist />;
    }

    getTabContent() {
        const {
            immAccounts,
            immBrokerMyInvestments,
            immBrokerWallets,
            getStocksByContract,
            postWalletAlias,
            setOrdersAndMovementsAccessFrom,
            setOrdersAndMovementsContract,
            onOpenTraderClick,
            getContractState,
            immBrokerContractState,
            immBrokerLandingLoader
        } = this.props;

        const activeTab = immBrokerLandingLoader.get('activeTab');
        const isFetchingStocksByContract = immBrokerWallets.get('isFetchingProducts');
        const immStocksByContract = immBrokerWallets.get('walletList');
        const immStocksContracts = immBrokerMyInvestments.get('contracts');
        const immStocksByType = immBrokerMyInvestments.get('products');
        const isFetchingStocksByType = immBrokerMyInvestments.get('isFetching');
        const immFundsContributionsList = immBrokerMyInvestments.get('fundsContributionsList');

        if (activeTab == 0) {
            return (<BrokerMyInvestmentsProducts
                immStocksByType={immStocksByType}
                isFetchingStocksByType={isFetchingStocksByType}
                displayAlternativeFunds={false}
                displayStocks={false}
                displayWarrants={false}
                displayETFs={false}
                displayFunds={true}
                displayCrypto={false}
                displayPlans={false}
                displayOthers={false}
                startExpanded={true}
                alternativeValueColumnTitle={true}
                displayFooter={false}
                onOpenTraderClick={onOpenTraderClick}
                setOrdersAndMovementsAccessFrom={setOrdersAndMovementsAccessFrom}
                resetSpecificProduct={this.props.resetSpecificProduct}
                pageName={PROC_BROKER_FUNDS_PG_NAME}
                immFundsContributionsList={immFundsContributionsList}
            />);
        }

        return (
            <BrokerMyInvestmentsContracts
                getStocksByContract={getStocksByContract}
                immAccounts={immAccounts}
                immStocksByContract={immStocksByContract}
                immStocksContracts={immStocksContracts}
                immStocksByType={immStocksByType}
                isFetchingStocksByContract={isFetchingStocksByContract}
                postWalletAlias={postWalletAlias}
                setOrdersAndMovementsContract={setOrdersAndMovementsContract}
                onInternalTransferFundsClick={this.props.onInternalTransferFundsClick}
                onOpenTraderClick={onOpenTraderClick}
                displayStocks={false}
                displayFunds={true}
                displayPlans={false}
                displayFooter={false}
                displayCrypto={false}
                getContractState={getContractState}
                immBrokerContractState={immBrokerContractState}
                immFundsContributionsList={immFundsContributionsList}
            />
        );
    }

    buildFundsTabbedContent() {
        const {
            immBrokerMyInvestments,
        } = this.props;

        const immStocksByType = immBrokerMyInvestments.get('products');
        const funds = immStocksByType.get('funds');
        const emptyStocks = !funds || funds.get('stocks').size === 0;
        const isFetchingStocksByType = immBrokerMyInvestments.get('isFetching');
        const title = formatText('funds-myPositions');
        const tab = this.getTabContent();

        if (!isFetchingStocksByType && emptyStocks) {
            return undefined;
        }
        return (
            <ContentBox
                id={"brokerFunds"}
                title={title}
                customClassName={"tabbed-content-box broker-my-investments"}
            >
                {tab}
            </ContentBox>
        );
    }

    buildProductInfoContent() {
        const { immBrokerMyInvestments } = this.props;
        const immStocksByType = immBrokerMyInvestments.get('products');
        const funds = immStocksByType.get('funds');
        const emptyStocks = !funds || funds.get('stocks').size === 0;
        const productType = showGDI ? TYPE_CM : TYPE_FUNDS;

        return (
            <BrokerInformationAboutProduct
                productType={productType}
                onBuyClick={() => this.handleBuyClick('comercialCard')}
                hasButton={!emptyStocks}
                externalLink={showGDI}
                pageName={PROC_BROKER_FUNDS_PG_NAME}
            />
        );
    }

    buildLegalText() {
        const text1 = formatText('broker-fundsLegalText1')

        const link1 = (
            <OKLink
                to={formatText('broker-fundsLegalTextUrl1')}
                modifier="emphasize"
            >
                <FormattedText value="broker-fundsLegalTextLinkText1" />
            </OKLink>
        );

        const link2 = (
            <OKLink
                to={formatText('broker-fundsLegalTextUrl2')}
                modifier="emphasize"
            >
                <FormattedText value="broker-fundsLegalTextLinkText2" />
            </OKLink>
        );

        const text2 = (
            <FormattedTextWithComponents
                value="broker-fundsLegalText2"
                injectedComponents={[link1, link2]}
            />
        );

        return (
            <div className="broker-funds-view__legal-text">
                <div className="broker-funds-view__legal-text-paragraph1">
                    {text1}
                </div>
                <div className="broker-funds-view__legal-text-paragraph2">
                    {text2}
                </div>
            </div>
        );
    }

    handleBuyClick() {
        this.props.resetSpecificProduct(TYPE_FUNDS.toUpperCase());

        if (!showGDI) {
            this.props.history.push(MYPROFILE_BROKER_EXPLORE_FUNDS_URL);
        } else {
            window.location.replace(getPublicSitePath('GDIPath'));
        }
    }

    handleBuySearchClick(component) {
        taggingEventHandled(PROC_BROKER_FUNDS_PG_NAME, component === 'comercialCard' ? 'buyButtonComCard' : 'buyButton');
        this.props.resetSpecificProduct(TYPE_FUNDS.toUpperCase());
        this.props.history.push(MYPROFILE_BROKER_EXPLORE_FUNDS_URL);
    }

    render() {
        const { immBrokerMyInvestments } = this.props;
        const productInfoContent = this.buildProductInfoContent();
        const callMeBackContent = this.buildCallMeBackContent();
        const brokerMostPopularOfMonthContent = this.buildBrokerMostPopularOfMonthContent();
        const fundsTabbedContent = this.buildFundsTabbedContent();
        let fundsTabbedContentObject = null;
        let fundsCTAsObject = null;
        const buySellBtnText = formatText('broker-buySellBtnText');
        const searchButtonText = formatText('brokerSearchWidget-brokerSearchWidget_searchFunds');
        const isFetchingStocksByType = immBrokerMyInvestments.get('isFetching');
        const lang = getLanguage().toLowerCase();
        const links = lang === 'es' || lang === 'en' || lang === 'pt'
            ? []
            : [getPublicSiteUrl(), CNMV_URL];

        let actionLinkButton = (
            <div className="broker-general-view__action-link-btn col-sm-4">
                <OKButton
                    modifier="primary"
                    onClick={this.handleBuySearchClick}
                >
                    {buySellBtnText}
                </OKButton>
            </div>
        );

        const searchButton = (
            <div className="broker-general-view__action-link-btn col-sm-8">
                <OKButton
                    modifier="secondary"
                    leftIcon="icon-s-buscar"
                    block={true}
                    onClick={() => {
                        taggingEventHandled(PROC_BROKER_FUNDS_PG_NAME, 'searchButton');
                        this.props.handleShowSearchWidget()
                    }}
                >
                    {searchButtonText}
                </OKButton>
            </div>
        );

        if (!isFetchingStocksByType) {
            if (fundsTabbedContent) {
                fundsTabbedContentObject = (
                    <div className="row">
                        <div className="col-xs-12 col-md-8 broker-general-view__custom-product-loader">
                            <BrokerCustomProductLoader pageName={PROC_BROKER_FUNDS_PG_NAME} />
                        </div>
                        <div className="col-xs-12 col-md-4 broker-general-view__general-action-link-group">
                            {searchButton}
                            {actionLinkButton}
                        </div>
                        <div className="col-md-12 grid-view--fix-cell-separation">
                            {fundsTabbedContent}
                        </div>
                    </div>
                );
            } else {
                fundsCTAsObject = (
                    <div className="row">
                        <div className="col-md-12 broker-general-view__landing-action-link-group">
                            {searchButton}
                            {actionLinkButton}
                        </div>
                    </div>
                );
            }
        }
        else {
            fundsTabbedContentObject = <LoadingSection />
        }

        return (
            <div className="broker-funds-view">
                <div className="broker-general-view__search-widget">
                    <BrokerSearchWidget product={TYPE_FUNDS} />
                </div>
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="higher-small" section="broker" customClass="col-xs-12">
                            <BrokerTruncatedBreadcrumb
                                titleKey="funds-title"
                                breadcrumbConfig={this.breadcrumb}
                            />
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid grid-view--content-position-positive">
                        <div className="broker-funds-view__broker-risk-indicator">
                            <BrokerRiskIndicator
                                riskValue={0}
                                links={links}
                                textContent="brokerRiskInformationBox-brokerRiskInformationBox_descriptionFunds"
                                productType="Funds"
                            />
                        </div>
                        {fundsTabbedContentObject}
                        <div className="row">
                            <div className="col-xs-12 col-md-8">
                                <div className="row">
                                    <FeatureTogglingRender notAllowedProductKey={DIVERSIFIED_INVESTMENT}>
                                        <div className={`col-md-12 ${fundsTabbedContent ? 'grid-view--fix-cell-separation' : ''}`}>
                                            {productInfoContent}
                                        </div>
                                    </FeatureTogglingRender>
                                    <FeatureTogglingRender notAllowedProductKey={MORNINGSTAR_MOST_POPULAR} >
                                        <div className="col-md-12 grid-view--fix-cell-separation">
                                            {brokerMostPopularOfMonthContent}
                                        </div>
                                    </FeatureTogglingRender>
                                </div>
                            </div>
                            <div className="col-xs-12 col-md-4">
                                {fundsCTAsObject}
                                <div className="row">
                                    <div className="col-md-12 grid-view--fix-cell-separation">
                                        {callMeBackContent}
                                    </div>
                                    <div className="col-md-12 grid-view--fix-cell-separation">
                                        <CommercialAds path="broker/funds" type="banner-a" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <FeatureTogglingRender notAllowedProductKey={MORNINGSTAR_MOST_POPULAR} >
                                <div className="col-xs-12 grid-view__sources">
                                    {this.buildLegalText()}
                                </div>
                            </FeatureTogglingRender>
                        </div>
                    </div>
                </div>
                <div className="container-fluid grid-view__cross-selling">
                    <div className="row">
                        <CommercialAds path="broker/general" type="cross-selling" />
                    </div>
                </div>
            </div>
        );
    }
}

BrokerFundsView.propTypes = {
    history: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immBrokerMyInvestments: PropTypes.object.isRequired,
    immBrokerWallets: PropTypes.object.isRequired,
    getStocksByType: PropTypes.func.isRequired,
    getStocksContracts: PropTypes.func.isRequired,
    getStocksByContract: PropTypes.func.isRequired,
    postWalletAlias: PropTypes.func.isRequired,
    onOpenTraderClick: PropTypes.func.isRequired,
    setOrdersAndMovementsAccessFrom: PropTypes.func.isRequired,
    setOrdersAndMovementsContract: PropTypes.func.isRequired,
    onInternalTransferFundsClick: PropTypes.func.isRequired,
    getContractState: PropTypes.func,
    immBrokerContractState: PropTypes.object,
    immBrokerLandingLoader: PropTypes.object.isRequired,
    handleShowSearchWidget: PropTypes.func.isRequired,
    resetSpecificProduct: PropTypes.func
};

module.exports.constructor = BrokerFundsView;
module.exports.BrokerFundsView = connect(
    state => ({
        immAccounts: state.accounts,
        immBrokerMyInvestments: state.brokerMyInvestments,
        immBrokerContractState: state.brokerContractState,
        immBrokerWallets: state.brokerWallets,
        immBrokerLandingLoader: state.brokerLandingLoader,
    }),
    {
        getContractState: brokerContractState.getContractState,
        getStocksByType: BrokerStocksByTypeActions.getStocksByType,
        getStocksContracts: BrokerStocksByContractActions.getWalletList,
        getStocksByContract: BrokerStocksByContractActions.getStocksByWallet,
        postWalletAlias: BrokerStocksByContractActions.postWalletAlias,
        onOpenTraderClick: BrokerOpenTraderActions.openLink,
        setOrdersAndMovementsAccessFrom: BrokerOrdersAndMovementsActions.setAccessFrom,
        setOrdersAndMovementsContract: BrokerOrdersAndMovementsActions.setContractNumber,
        onInternalTransferFundsClick: BrokerInternalTransferFundsActions.setOriginFund,
        handleShowSearchWidget: BrokerSearchWidgetActions.showSearchWidget,
        resetSpecificProduct: BrokerProductFiltersSearchActions.resetSpecificProduct
    }
)(withRouter(BrokerFundsView));
